import { Button, Card } from 'antd';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="page-shell">
      <section className="page-hero">
        <h1>404</h1>
        <p>Aradığınız sayfa bulunamadı.</p>
      </section>

      <Card className="surface-card" style={{ textAlign: 'center' }}>
        <p className="muted-copy" style={{ marginBottom: 16 }}>
          Link eski olabilir veya adres yanlış yazılmış olabilir.
        </p>
        <Link to="/">
          <Button type="primary">Anasayfaya Dön</Button>
        </Link>
      </Card>
    </div>
  );
};

export default NotFoundPage;
